export default {
  path: '/agr-stock',
  redirect: { name: 'AgrList' },
  component: () => import('@/views/layout/Container'),
  children: [
    {
      path: 'list',
      name: 'AgrList',
      component: () => import('@/views/agrStock/AgrList'),
      meta: {
        title: '农资管理'
      }
    },
    {
      path: 'add',
      name: 'AgrAdd',
      component: () => import('@/views/agrStock/AgrAdd'),
      meta: {
        title: '添加农资'
      }
    },
    {
      path: 'create',
      name: 'AgrCreate',
      component: () => import('@/views/agrStock/AgrCreate'),
      meta: {
        title: '新增农资'
      }
    }
  ]
}
